import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiTrash2, FiX, FiAlertTriangle } from "react-icons/fi";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, messageContent }) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="msgx-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="msgx-modal msgx-modal-delete"
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 400 }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button className="msgx-modal-close" onClick={onClose}>
              <FiX />
            </button>

            {/* Icon */}
            <motion.div
              className="msgx-delete-icon"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{
                type: "spring",
                damping: 15,
                stiffness: 400,
                delay: 0.1,
              }}
            >
              <FiAlertTriangle />
            </motion.div>

            {/* Title */}
            <h3 className="msgx-delete-title">Delete Message?</h3>

            {/* Description */}
            <p className="msgx-delete-description">
              Are you sure you want to delete this message? This action cannot
              be undone.
            </p>

            {/* Message Preview */}
            {messageContent && (
              <motion.div
                className="msgx-delete-preview"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.15 }}
              >
                <span>
                  "
                  {messageContent.length > 50
                    ? messageContent.substring(0, 50) + "..."
                    : messageContent}
                  "
                </span>
              </motion.div>
            )}

            {/* Actions */}
            <div className="msgx-modal-actions">
              <motion.button
                className="msgx-btn msgx-btn-secondary"
                onClick={onClose}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Cancel
              </motion.button>
              <motion.button
                className="msgx-btn msgx-btn-danger"
                onClick={handleConfirm}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <FiTrash2 />
                Delete
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DeleteConfirmModal;
